import React from 'react';

export const ShieldKeyhole = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.252 3.8823C2 4.24097 2 5.30764 2 7.43897V8.4883C2 12.247 4.826 14.0716 6.59933 14.8456C7.08 15.0556 7.32067 15.161 8 15.161C8.68 15.161 8.92 15.0556 9.40067 14.8456C11.174 14.071 14 12.2476 14 8.4883V7.43897C14 5.30697 14 4.24097 13.748 3.8823C13.4967 3.5243 12.4947 3.18097 10.49 2.49497L10.108 2.3643C9.06333 2.0063 8.54133 1.82764 8 1.82764C7.45867 1.82764 6.93667 2.0063 5.892 2.3643L5.51 2.4943C3.50533 3.18097 2.50333 3.5243 2.252 3.8823ZM9 10.4943C9 10.6711 8.92976 10.8407 8.80474 10.9657C8.67971 11.0907 8.51014 11.161 8.33333 11.161H7.66667C7.48986 11.161 7.32029 11.0907 7.19526 10.9657C7.07024 10.8407 7 10.6711 7 10.4943V9.5603C6.61789 9.34064 6.31908 9.00088 6.15002 8.59384C5.98097 8.1868 5.95115 7.73531 6.0652 7.30958C6.17926 6.88385 6.4308 6.50773 6.7807 6.23973C7.1306 5.97172 7.55925 5.82685 8 5.82764C8.44047 5.8274 8.86869 5.97258 9.2182 6.24063C9.56771 6.50868 9.81896 6.88462 9.93294 7.31008C10.0469 7.73554 10.0173 8.18673 9.84858 8.59361C9.67988 9.00049 9.38159 9.34031 9 9.5603V10.4943Z"
        fill="currentColor"
      />
    </svg>
  );
};
